import Spinner from '@rio-cloud/rio-uikit/Spinner';
import { useEffect } from 'react';

export const TOURSERVICE_REDIRECT_URL = 'https://order-communication-web.tour-tracking.rio.cloud/#/tourservice';

const TourServicePage = () => {
    useEffect(() => {
        window.location.replace(TOURSERVICE_REDIRECT_URL);
    }, []);

    return <Spinner />;
};

export default TourServicePage;
